import React, { useState } from 'react';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import { checkMot } from '../../../../ressources/functionJS/checkMot';

const SelectPrivilege = ({
  listePrivilegesParCategorie,
  gererPrivilege,
  desactive,
}) => {
  const [privilegesCategorie, setPrivilegesCategorie] = useState('defaut');

  const gererCategorieSelection = (event) => {
    gererPrivilege(listePrivilegesParCategorie[event.target.value]);
    setPrivilegesCategorie(event.target.value);
  };

  const afficheOptionsPrivileges = Object.keys(
    listePrivilegesParCategorie || {}
  ).map((optionKey) => (
    <option key={optionKey} value={optionKey}>
      {checkMot(optionKey)}
    </option>
  ));

  return (
    <>
      <select
        className={[s.custom_select, s.mr_sm_2].join(' ')}
        value={privilegesCategorie}
        name={privilegesCategorie}
        onChange={gererCategorieSelection}
        disabled={desactive}
      >
        {/* Invite seulement : value valait null, que React ignore, si bien
            que la choisir renvoyait son libellé traduit comme nom de
            catégorie, et gererPrivilege recevait undefined. */}
        <option key={'default'} value="defaut" disabled>
          {checkMot('selection_categorie_privilege')}
        </option>
        {afficheOptionsPrivileges}
      </select>
    </>
  );
};

export default SelectPrivilege;
